// extracted by mini-css-extract-plugin
export var box = "_5c-1";
export var checked = "_5c-2";
export var descriptionSpacer = "_5c-9";
export var disabled = "_5c-3";
export var icon = "_5c-6";
export var input = "_5c-0";
export var labelSpacer = "_5c-8";
export var medium = "_5c-5";
export var small = "_5c-4";
export var text = "_5c-7";